<template>
  <v-card
    :class="mainEventCardClass"
    :style="{
      'min-width': isSmallMobile ? '285px' : isMobile ? '19.7em' : '20.6em',
      'max-width': isSmallMobile ? '285px' : isMobile ? '19.7em' : '20.6em',
    }"
  >
    <v-card-text class="d-flex flex-column pa-2 pt-2">
      <div class="d-flex justify-space-between align-center subtitle-2">
        <div style="font-size: 0.8rem;" class="d-flex align-center">
          <v-img
            :src="
              `https://dozr8la71aog.cloudfront.net/flags/1x1/${event.category_flag}.svg`
            "
            class="mr-1"
            width="22"
            style="
              display: inline-block;
              vertical-align: baseline;
              border-radius: 20px;
              border: 2px solid rgba(255, 255, 255, 0.1);
            "
            :alt="`${event.category_flag}-flag`"
          />
          <div class="d-flex py-1">
            <div
              class="text-truncate"
              style="font-size: 0.8rem;"
              :style="{
                'max-width':
                  isSmallMobile && !event.startingSoon
                    ? '142px'
                    : isMobile && !event.startingSoon
                    ? '172px'
                    : event.startingSoon && isMobile
                    ? '145px'
                    : '198px',
              }"
            >
              {{ event.league_name }}
            </div>
            <v-btn x-small icon class="ml-1">
              <v-icon
                :color="favoriteColor(event.tournamentId)"
                @click="
                  addFavorite(
                    event.id_sport,
                    event.category_id,
                    event.tournamentId
                  )
                "
                size="16"
              >
                mdi-star
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div
          v-if="event.startingSoon"
          style="
            font-size: 0.75rem;
            text-align: right;
            width: 88px;
            line-height: 1rem;
          "
        >
          {{ event.startingSoon }}
        </div>
        <div
          v-else
          class="grey--text d-flex"
          style="font-size: 0.75rem; text-align: right; height: 32px;"
        >
          <div class="align-self-center">
            <span class="text-capitalize">
              {{ event.dayText }}
            </span>
            /
            {{
              new Date(event.scheduled).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
          </div>
        </div>
      </div>

      <v-spacer />

      <!-- H2H -->
      <div
        class="text-body-2 d-flex mx-0 mb-6 mt-2 justify-center cursor-pointer"
        @click="
          goToEvent(
            event.id_sport,
            event.category_id,
            event.tournamentId,
            event.id,
            event.categoryName,
            event.league_name,
            event.description,
            event.category_flag
          )
        "
      >
        <div class="d-flex">
          <div class="d-flex nameComp" style="height: 2.5em;">
            <span
              class="mr-2 hideLongNameTeam align-self-center text-end"
              :style="{
                'font-size': '0.75rem',
                width: isSmallMobile ? '72px' : isMobile ? '90px' : '95px',
              }"
            >
              {{ event.firstTeam }}
            </span>
            <TeamLogo
              class="align-self-center"
              type_size="large_logo"
              size="32px"
              :id_team="event.id_team_1"
              :id_sport="event.id_sport"
            />
          </div>

          <v-icon class="mx-2 grey--text" size="24">
            mdi-close
          </v-icon>

          <div class="d-flex nameComp" style="height: 2.5em;">
            <TeamLogo
              class="align-self-center"
              type_size="large_logo"
              size="32px"
              :id_team="event.id_team_2"
              :id_sport="event.id_sport"
            />
            <span
              class="ml-2 hideLongNameTeam align-self-center text-start"
              :style="{
                'font-size': '0.75rem',
                width: isSmallMobile ? '72px' : isMobile ? '90px' : '95px',
              }"
            >
              {{ event.secondTeam }}
            </span>
          </div>
        </div>
      </div>

      <div style="position: relative">
        <div
          v-if="
            event.odds.filter(
              (odd) =>
                odd.id_market == '1' &&
                odd.super_odds == '1' &&
                odd.active == '1'
            ).length > 0
          "
          class="mx-auto"
          style="position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -80%);"
        >
          <ArrowHorizontal />
        </div>
      </div>

      <div class="d-flex justify-space-between">
        <template v-for="odd in event.odds">
          <div
            class="d-flex align-center fill-height oddsMargin"
            style="
              flex: 1 0 auto;
              /* background-image: linear-gradient(to left, rgba(255,0,0,0), rgba(0,0,0,0.5)); */
              border-radius: 5px;
            "
            v-if="odd.show ? odd.show : true"
            :key="odd.id_odd"
          >
            <!-- ======== -->
            <!-- ODD CARD -->
            <div
              :key="odd.id_odd"
              style="
                flex: 1 0 auto;
              "
              :style="{
                width: `16px`,
                height: `32px`,
              }"
            >
              <!-- ODD BLOQUEADA -->
              <div
                class="
                  odd
                  text-center
                  d-flex
                  fill-height
                "
                v-if="odd.blocked"
              >
                <!-- LEGENDA -->
                <div
                  class="d-flex align-center justify-center"
                  style="
                    font-size: 12px;
                    width: 35%;
                  "
                >
                  {{ odd.legend }}
                </div>
                <!-- LOCK ICON -->
                <div
                  class="
                    fill-height
                    align-center
                    justify-center
                    d-flex
                  "
                  style="width: 55%"
                >
                  <i
                    aria-hidden="true"
                    class="
                      v-icon
                      notranslate
                      mdi mdi-lock
                      theme--dark
                    "
                    style="font-size: 18px"
                  ></i>
                </div>
              </div>
              <!-- ODD ATIVA -->
              <div
                class="
                  odd
                  text-center
                  d-flex
                  cursor-pointer
                  fill-height
                "
                v-else
                :class="[
                  {
                    colorOddSelectedTheme: coupons.some(
                      (item) => item.id_odd == odd.id_odd
                    ),
                  },
                ]"
                @click="
                  $selectOdd({
                    id_event: event.id,
                    id_odd: odd.id_odd,
                    description: event.description,
                    data: odd,
                  })
                "
              >
                <!-- LEGENDA -->
                <div
                  class="d-flex align-center justify-center"
                  style="font-size: 12px; width: 45%;"
                >
                  {{ odd.legend }}
                </div>
                <!-- ODD PRICE -->
                <div
                  class="
                    align-center
                    text-center
                    d-flex
                    justify-center
                    fill-height
                    colorOddText--text
                  "
                  style="font-size: 14px; width: 55%;"
                  :class="odd.id_odd"
                >
                  <div
                    style="position: relative; margin-top: 0.7rem;"
                    v-if="
                      odd.id_market == '1' &&
                        odd.super_odds == '1' &&
                        odd.active == '1' &&
                        Number(odd.margin) < 0
                    "
                  >
                    <p class="top-text oldOdd ma-0 pa-0">
                      {{
                        (
                          Number(odd.odd_price) /
                          (1 - Number(odd.margin))
                        ).toFixed(2)
                      }}
                    </p>
                    <p class="bottom-text ma-0 pa-0" style="font-size: 1rem">
                      {{ Number(odd.odd_price).toFixed(2) }}
                    </p>
                  </div>
                  <span v-else>
                    {{ Number(odd.odd_price).toFixed(2) }}
                  </span>
                </div>
              </div>
            </div>
            <!-- / ODD CARD -->
            <!-- ======== -->
          </div>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import TeamLogo from "@/components/team-logo/";
import storeFavorite from "@/util/storeFavorite";
import ArrowHorizontal from "@/assets/ArrowHorizontal";

export default {
  name: "MainEventCard",
  props: ["event", "index"],
  components: { TeamLogo, ArrowHorizontal },

  computed: {
    isSmallMobile() {
      return this.$vuetify.breakpoint.width <= 369;
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 750;
    },
    mainEventCardClass() {
      const _class = "colorDominant";

      // Melhora o contraste com a cor desses operadores
      if (["apostamaster", "jogodeourobet"].includes(this.$domain())) {
        return `${_class} darken-1`;
      }

      return _class;
    },
    coupons() {
      return this.$store.state.coupons;
    },
    favorites() {
      return this.$store.state.favoriteTournaments;
    },
  },

  methods: {
    goToEvent(
      sportId,
      categoryId,
      tournamentId,
      eventId,
      categoryName,
      tournamentName,
      eventDescription,
      categoryFlag
    ) {
      if (this.$permissions().bigTable) {
        this.$router.push({
          name: "btEvent",
          params: {
            sport: sportId,
            category: categoryId,
            tournament: tournamentId,
            event: eventId,
          },
          query: {
            sport: this.getNameSport(sportId),
            category: categoryName,
            tournament: tournamentName,
            event: eventDescription,
            mobile: this.$vuetify.breakpoint.smAndDown,
            liveEvent: false,
            flag: categoryFlag,
          },
          hash: "#scrollTop",
        });
      } else {
        this.$router.push({
          name: "eventsTournament",
          params: {
            sport: sportId,
            category: categoryId,
            tournament: tournamentId,
            event: eventId,
          },
          query: {
            sport: this.getNameSport(sportId),
            category: categoryName,
            tournament: tournamentName,
            event: eventDescription,
            liveEvent: false,
            mobile: this.$vuetify.breakpoint.mobile,
            flag: categoryFlag,
          },
          hash: "#scrollTop",
        });
      }
    },
    addFavorite(...args) {
      storeFavorite(...args);
    },
    favoriteColor(id_tournament) {
      return this.favorites.some(
        (item) => item.id_tournament == Number(id_tournament)
      )
        ? "yellow"
        : "grey";
    },
    getNameSport(sportId) {
      return this.$store.getters.getNameSportById(sportId);
    },
  },
};
</script>

<style scoped>
.oddsMargin:not(:last-child) {
  margin-right: 10px;
}

.main-events .hideLongNameTeam {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1rem;
}

.oldOdd {
  position: relative;
  text-decoration: none;
  display: inline-block;
  font-size: 0.7em;
}

.oldOdd::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #fff;
  transform: rotate(-30deg);
}

.bottom-text {
  position: relative;
}

.top-text {
  position: absolute;
  top: -15px;
  left: 0;
}
</style>
